import { render, staticRenderFns } from "./AxDockButton.vue?vue&type=template&id=42f015f8&scoped=true"
import script from "./AxDockButton.vue?vue&type=script&lang=ts"
export * from "./AxDockButton.vue?vue&type=script&lang=ts"
import style0 from "./AxDockButton.vue?vue&type=style&index=0&id=42f015f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f015f8",
  null
  
)

export default component.exports